export default "__VITE_ASSET__M642_6d7__"